import { FunctionComponent } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { Colors } from '~/assets/style/colors'
import Button from '~/components/Button'
import { useGlobalFlyout } from '~/components/layout/GlobalFlyout'
import { PageContent } from '~/components/PageContent'
import { TabProp, Tabs } from '~/components/Tabs'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { PureAdmGamIntegrationHelpFlyout } from '../adServers/PureAdmGamIntegrationHelpFlyout'
import { PureAdmTamIntegrationHelpFlyout } from './PureAdmTamIntegrationHelpFlyout'

type TabLabel = 'Prebid' | 'Amazon TAM' | 'Google Ad Manager'
const TabUrls: { [key in TabLabel]: string } = {
  Prebid: 'prebid',
  'Amazon TAM': 'tam',
  'Google Ad Manager': 'gam',
}

export const WrappersPage: FunctionComponent = () => {
  // Hooks
  const location = useLocation()
  const navigate = useNavigate()
  const breadcrumbs = useBreadcrumbs()
  const flyout = useGlobalFlyout()

  const wrapperTabs: TabProp[] = [
    {
      label: 'Prebid',
      active: /prebid\/?$/.test(location?.pathname ?? ''),
      trackingLabel: 'adm-wrappers-prebid-tab-apply',
    },
    {
      label: 'Amazon TAM',
      active: /tam\/?$/.test(location?.pathname ?? ''),
      trackingLabel: 'adm-wrappers-tam-tab-apply',
    },
    {
      label: 'Google Ad Manager',
      active: /gam\/?$/.test(location?.pathname ?? ''),
      trackingLabel: 'adm-wrappers-gam-tab-apply',
    },
  ]
  const activeTab = wrapperTabs.find((t) => t.active)?.label as TabLabel

  const onTabChange = (label: TabLabel) => {
    navigate(TabUrls[label])
  }

  const onNavigateToContextKeys = () => {
    navigate('/monetization/one/context/context-keys')
  }
  const onNavigateToAdUnits = () => {
    navigate('/monetization/one/adunits')
  }

  return (
    <PageContent
      breadcrumbs={breadcrumbs}
      headerActions={
        <>
          {activeTab === 'Amazon TAM' && (
            <Button
              variant={'tertiary'}
              onClick={() => flyout.open(PureAdmTamIntegrationHelpFlyout, { color: Colors.Violet, closeTrackingLabel: 'adm-integrations-tam-help-close' })}
              iconName={'help'}
              trackingLabel={'adm-integrations-tam-help'}
            >
              Help
            </Button>
          )}
          {activeTab === 'Google Ad Manager' && (
            <Button
              variant={'tertiary'}
              onClick={() =>
                flyout.open(
                  PureAdmGamIntegrationHelpFlyout,
                  { color: Colors.Violet, closeTrackingLabel: 'adm-integrations-gam-help-close' },
                  {
                    navigateToAdUnits: () => {
                      flyout.close()
                      onNavigateToAdUnits()
                    },
                    navigateToContextKeys: () => {
                      flyout.close()
                      onNavigateToContextKeys()
                    },
                  }
                )
              }
              iconName={'help'}
              trackingLabel={'adm-integrations-gam-help'}
            >
              Help
            </Button>
          )}
        </>
      }
    >
      <Tabs tabs={wrapperTabs} onClick={(tab) => onTabChange(tab.label as TabLabel)} />
      <Outlet></Outlet>
    </PageContent>
  )
}
